import React, {Component} from 'react';
import PromocionesNavBar from '../Promociones/PromocionesSubComponents/PromocionesNavBar';
import PromocionesConDescuento from '../Promociones/PromocionesSubComponents/PromocionesConDescuento';

import axios from 'axios';
import c from '../../Constants';
import {Glyphicon} from 'react-bootstrap';

//CSS
import './Promociones.css';
import Footer from "../../layout/Footer/Footer";



class Promociones extends Component {

    constructor() {
        super();

        // this.handleScroll = this.handleScroll.bind(this);

        this.state = {
            intervalId: 0,
            scrollStepInPx: 50,
            delayInMs: 10,
            showUp: true,
            categorias:[]
        };

        this.finishedScroll = true;
    }

    componentDidMount() {
        window.scroll(0,0);
        // axios.get(c.BASE_URL + '/api/categorias')
        //     .then(res => {
        //         this.setState({categorias:res.data})
        //     })
        //     .catch((error) => {
        //         console.log(error);
        //     })

    };
    //
    // componentWillUnmount() {
    //     window.removeEventListener('scroll', this.handleScroll);
    // };
    //
    // handleScroll(event) {
    //     if(event.srcElement.scrollingElement.scrollTop > 130) {
    //         this.setState({showUp: true});
    //     }
    //     else {
    //         this.setState({showUp: false});
    //     }
    // };
    scrollStep() {
        if (window.pageYOffset === 0) {
            clearInterval(this.state.intervalId);
            this.finishedScroll = true;
        }
        window.scroll(0, window.pageYOffset - this.state.scrollStepInPx);
    }

    scrollToTop() {
        if (this.finishedScroll) {
            let intervalId = setInterval(this.scrollStep.bind(this), this.state.delayInMs);
            this.setState({intervalId: intervalId});
            this.finishedScroll = false;
        }
    }


    render() {
        return (
            <div className="promo-bg">
                <PromocionesNavBar/>
                {/*<PromocionesActuales id="actuales"/>*/}
                <PromocionesConDescuento/>
                {/*<PromocionesConCombo/>*/}
                {/*<PromocionesFooter/>*/}
                <div className="to-top" style={(this.state.showUp) ? {display: "inline"} : {display: "none"}}
                     onClick={() => {
                         this.scrollToTop();
                     }}>
                    <Glyphicon glyph="menu-up"/>
                </div>
                <Footer/>
            </div>
        );
    }
}


export default Promociones;


// WEBPACK FOOTER //
// ./src/pages/Promociones/Promociones.js